import { serverNamePhp, request } from '../configs.js';

export const listPackagesRequests = {
  listPackages: (type) => {
    return request.get(`${serverNamePhp}/listar-pacotes.php?tipo=${type}&v=${Math.random()}`, { cache: 'no-store' });
  }
};

export default listPackagesRequests;
